var map = {
	"./afro.jpg": "5cca",
	"./bacon.jpg": "4016",
	"./baseball.jpg": "efa8",
	"./boat.jpg": "66f3",
	"./breakfast.jpg": "f5be",
	"./cheese.jpg": "52f7",
	"./cupcake.jpg": "d627",
	"./educate.jpg": "8aa5",
	"./fashion.jpg": "7ccc",
	"./fun.jpg": "d251",
	"./memories.jpg": "3959",
	"./ment.jpg": "3dd0",
	"./skate.jpg": "a29f",
	"./skincare.jpg": "18c6",
	"./space.jpg": "98ec",
	"./tour.jpg": "ffc2",
	"./tuna.jpg": "1902",
	"./vegan.jpg": "0fc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2bdd";